import {QuestionMarkCircleIcon} from '@heroicons/react/24/outline';
import classNames from 'classnames';
import {CSSProperties, ReactNode} from 'react';

export type AlertBoxProps = {
  className?: string;
  children: ReactNode;
  style?: CSSProperties;
};

const AlertBox = (props: AlertBoxProps) => {
  const {className, style, children} = props;

  return (
    <div
      className={classNames(
        'flex rounded-full min-w-[3rem] text-white text-base bg-red-200 items-center p-3',
        className
      )}
      style={style}
    >
      <QuestionMarkCircleIcon className="w-sm mr-3" />
      {children}
    </div>
  );
};

export default AlertBox;
